import {createFileRoute, useParams} from '@tanstack/react-router'
import ItemEditor from "@components/itemEditor.tsx";

export const Route = createFileRoute('/_authenticated/items/detail/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const {id} = useParams({from: '/_authenticated/items/detail/$id'})

  return <ItemEditor id={Number(id)} />
}
